import { FormBase } from "../../util/form-base-form";

export class PointRuleAdminForm extends FormBase {
    public root: HTMLElement;

    public constructor(root: HTMLElement) {
        super();
        this.root = root;
    }

    public static getRoots(root: ParentNode): HTMLElement[] {
        return new PointRuleAdminForm(document.body).queryElements(root, ".point-rules-admin", HTMLElement);
    }

    public getRoot(): HTMLElement {
        return this.root;
    }

    public isInitialized(): boolean {
        return this.root.dataset.pointRulesAdminInit === "1";
    }

    public markInitialized(): void {
        this.root.dataset.pointRulesAdminInit = "1";
    }

    public getListEl(): HTMLElement | null {
        return this.queryElement(this.root, ".users-admin__list", HTMLElement);
    }

    public getEditButton(root: EventTarget | Element | null | undefined): HTMLButtonElement | null {
        return this.closest(root, ".js-point-rule-edit-toggle", HTMLButtonElement);
    }

    public getRow(root: EventTarget | Element | null | undefined): HTMLFormElement | null {
        return this.closest(root, ".users-admin__row", HTMLFormElement);
    }

    public getSubmitButton(root: ParentNode): HTMLButtonElement | null {
        return this.queryElement(root, 'button[type="submit"]', HTMLButtonElement);
    }

    public getField(root: ParentNode, name: string): HTMLElement | null {
        return this.queryElement(root, `[name="${name}"]`, HTMLElement);
    }

    public getFieldDisplay(root: ParentNode, field: string): HTMLElement | null {
        return this.queryElement(root, `[data-field="${field}"]`, HTMLElement);
    }
}
